(function () {
  function init(root) {
    if (!root || root.dataset.m1v2ProofInit === '1') return;
    root.dataset.m1v2ProofInit = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-proof-card]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-proof-panel]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-proof-dot]'));
    var stage = root.querySelector('[data-proof-stage]');
    if (!cards.length) return;

    var index = 0;
    var mq = window.matchMedia('(min-width: 1100px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var startX = 0;
    var scrollEnabled = false;
    var scrollStart = 0;
    var scrollStep = 0;
    var scrollFrame = 0;
    var pendingIndex = null;
    var hasEntered = false;
    var animLock = false;
    var FADE_OUT_MS = 320;

    function playReveal() {
      if (reduceMotion) {
        root.classList.add('is-reveal');
        return;
      }
      root.classList.remove('is-reveal');
      void root.offsetWidth;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          root.classList.add('is-reveal');
        });
      });
    }

    function renderCards() {
      var desktop = mq.matches;
      cards.forEach(function (card, i) {
        var current = i === index;
        var preview = desktop && i === index + 1;
        card.classList.toggle('is-current', current);
        card.classList.toggle('is-preview', preview);
        card.hidden = !(current || preview);
        card.setAttribute('aria-pressed', current ? 'true' : 'false');
        card.tabIndex = current || preview ? 0 : -1;
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-current', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.style.setProperty('--m1v2-proof-index', String(index));
      root.style.setProperty('--m1v2-proof-count', String(cards.length || 1));
      if (stage) stage.classList.toggle('is-solo', index >= cards.length - 1);
      root.classList.add('is-ready');
    }

    function renderPanels() {
      var activeId = cards[index].getAttribute('data-proof');
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-proof-panel') === activeId;
        panel.classList.toggle('is-current', on);
        panel.hidden = !on;
      });
    }

    function render() {
      renderCards();
      renderPanels();
    }

    function go(next, fromScroll) {
      if (next < 0 || next >= cards.length) return false;
      if (scrollEnabled && !fromScroll) {
        window.scrollTo({ top: scrollStart + next * scrollStep + 1, behavior: 'smooth' });
        return true;
      }
      if (next === index) {
        pendingIndex = null;
        return false;
      }
      if (animLock) {
        pendingIndex = next;
        return false;
      }

      // Text (left / bottom) updates immediately; media (right / top) fades.
      index = next;
      renderCards();

      if (reduceMotion || !hasEntered) {
        renderPanels();
        if (hasEntered) root.classList.add('is-reveal');
        return true;
      }

      animLock = true;
      root.classList.remove('is-reveal');

      window.setTimeout(function () {
        renderPanels();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            root.classList.add('is-reveal');
            window.setTimeout(function () {
              animLock = false;
              if (pendingIndex !== null) {
                var pending = pendingIndex;
                pendingIndex = null;
                go(pending, true);
              }
            }, 480);
          });
        });
      }, FADE_OUT_MS);

      return true;
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (!mq.matches) return;
        if (i === index) go(index - 1);
        else go(i);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          card.click();
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        go(i);
      });
    });

    // A sticky viewport with native page scroll advances every proof step.
    // Pointer location is irrelevant; scrolling backwards reverses the sequence.
    function syncScroll() {
      scrollFrame = 0;
      if (!scrollEnabled) return;
      var next = Math.max(0, Math.min(cards.length - 1,
        Math.floor((window.scrollY - scrollStart) / scrollStep)));
      go(next, true);
    }

    function requestScrollSync() {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(syncScroll);
    }

    function measureScroll() {
      var section = root.querySelector('.m1v2-proof__section');
      var inner = root.querySelector('.m1v2-proof__inner');
      if (!section || !inner) return;
      var stickyHeader = document.querySelector('#shopify-section-header, .shopify-section-header, sticky-header');
      var headerHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
      var viewportTop = Math.min(120, Math.max(24, headerHeight + 12));
      // Let the section travel farther before pinning, removing the excess top gap.
      var pinDelay = Math.round(Math.max(48, Math.min(144, (window.innerHeight - 600) * 0.32)));
      var top = viewportTop - pinDelay;
      scrollEnabled = mq.matches && !reduceMotion && cards.length > 1 &&
        window.innerHeight - viewportTop >= 480 && root.isConnected;
      root.classList.toggle('is-scroll-driven', scrollEnabled);
      root.style.setProperty('--m1v2-proof-top', top + 'px');
      root.style.setProperty('--m1v2-proof-viewport-top', viewportTop + 'px');
      if (!scrollEnabled) {
        root.style.removeProperty('--m1v2-proof-travel');
        return;
      }
      scrollStep = Math.max(380, Math.round(window.innerHeight * 0.65));
      root.style.setProperty('--m1v2-proof-travel', (scrollStep * cards.length) + 'px');
      scrollStart = root.getBoundingClientRect().top + window.scrollY - top;
      requestScrollSync();
    }

    window.addEventListener('scroll', requestScrollSync, { passive: true });
    window.addEventListener('resize', measureScroll, { passive: true });
    window.addEventListener('load', measureScroll, { once: true });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) {
        window.removeEventListener('scroll', requestScrollSync);
        window.removeEventListener('resize', measureScroll);
        window.removeEventListener('load', measureScroll);
        if (layoutObserver) layoutObserver.disconnect();
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      }
    });
    if ('ResizeObserver' in window) {
      var lastBodyHeight = 0;
      var layoutObserver = new ResizeObserver(function () {
        var bodyHeight = document.body.offsetHeight;
        if (bodyHeight !== lastBodyHeight) {
          lastBodyHeight = bodyHeight;
          measureScroll();
        }
      });
      layoutObserver.observe(document.body);
    }

    root.addEventListener('touchstart', function (event) {
      if (!event.changedTouches.length) return;
      startX = event.changedTouches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (mq.matches || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - startX;
      if (dx <= -48) go(index + 1);
      if (dx >= 48) go(index - 1);
    }, { passive: true });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', function () {
        render();
      });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(function () {
        render();
      });
    }

    render();
    measureScroll();

    var observeTarget = stage || root;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      hasEntered = true;
      playReveal();
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hasEntered = true;
            playReveal();
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.28, rootMargin: '0px 0px -6% 0px' }
      );
      observer.observe(observeTarget);
    }
  }

  function boot() {
    document.querySelectorAll('[data-m1v2-proof]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-m1v2-proof]');
    if (!root) return;
    delete root.dataset.m1v2ProofInit;
    init(root);
  });
})();
